
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import ToolGrid from '../components/ToolGrid';

const HomePage = ({ onToolSelect }) => {
  const { t } = useTranslation();
  const [activeIndex, setActiveIndex] = useState(null);

  const onQuestionClick = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  const faqData = t('app.home.faq', { returnObjects: true }) || [];

  return (
    <div className="home-page" style={{ textAlign: 'center' }}>
      <p style={{ fontSize: '0.9em', color: '#555' }}>{t('app.home.fileSecurity')}</p>
      <ToolGrid onToolSelect={onToolSelect} />

      <div className="how-it-works" style={{ margin: '40px -2rem', padding: '40px 2rem', backgroundColor: '#0078D4', color: 'white' }}>
        <h2>{t('app.home.howItWorks')}</h2>
        <div style={{ display: 'flex', justifyContent: 'center', gap: '20px', flexWrap: 'wrap' }}>
          <div style={{ flex: '1', maxWidth: '300px' }}>
            <div style={{ fontSize: '3rem' }}>🧰</div>
            <h3>{t('app.home.step1Title')}</h3>
            <p>{t('app.home.step1Desc')}</p>
          </div>
          <div style={{ flex: '1', maxWidth: '300px' }}>
            <div style={{ fontSize: '3rem' }}>📤</div>
            <h3>{t('app.home.step2Title')}</h3>
            <p>{t('app.home.step2Desc')}</p>
          </div>
          <div style={{ flex: '1', maxWidth: '300px' }}>
            <div style={{ fontSize: '3rem' }}>📥</div>
            <h3>{t('app.home.step3Title')}</h3>
            <p>{t('app.home.step3Desc')}</p>
          </div>
        </div>
      </div>

      <div className="faq" style={{ margin: '40px -2rem', padding: '20px 2rem', backgroundColor: '#f8f9fa' }}>
        <h2>{t('app.home.faqTitle')}</h2>
        <div style={{ maxWidth: '800px', margin: '0 auto' }}>
          {faqData.map((faq, index) => (
            <div key={index} style={{ backgroundColor: 'white', padding: '20px', borderRadius: '8px', boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)', marginBottom: '20px', textAlign: 'left' }}>
              <div onClick={() => onQuestionClick(index)} style={{ cursor: 'pointer', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <h4>{faq.question}</h4>
                <span style={{ fontSize: '1.5rem' }}>{activeIndex === index ? '−' : '+'}</span>
              </div>
              {activeIndex === index && <p style={{ marginTop: '10px' }}>{faq.answer}</p>}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default HomePage;

